
<template>

	<div>
		<template v-for="( desc, ind ) in visible_models">
			<model v-if="active_model.endsWith(desc.key)" :key="ind" :ref="desc.key" :id="id" :desc="desc" :group_id="group_id" :data="data"/>
		</template>
	</div>

</template>

<script>

import model from "./model"

export default
{
	props :
	{
		id : String,
		group_id : String,
		data : Object,
		active_model : String,
	},

	components :
	{
		model,
	},

	computed :
	{
		visible_models()
		{
			return this.models.filter(model => this.data.printable_formula_html[model.key] != null)
		},
	},

	data()
	{
		return {

			models :
			[
				{ name : "Линейная", key : "add" },
				{ name : "Мультипликативная степенная", key : "mult" },
				{ name : "Экспоненциальная", key : "exp" }
			],

		}
	},

	methods :
	{
	}
}

</script>

